export const isExcelFile = (file: File): boolean => {
  const name = file?.name?.toLowerCase() || '';
  const type = file?.type || '';
  return (
    name.endsWith('.xlsx') ||
    name.endsWith('.xls') ||
    type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    type === 'application/vnd.ms-excel'
  );
};
